import { breakpoints } from '../helpers/breakpoints';
import { BRANDS, determineBrandFromURL } from '../helpers/brand';

export const doubleImageHeaderContainer = () => {
  let tickingResize = false;
  const brand = determineBrandFromURL();

  const headerComponent = document.querySelector<HTMLElement>(
    "[data-content-element-type-alias='doubleImageHeaderContainer']"
  );
  const headerComponentInner = headerComponent?.querySelector<HTMLElement>('.h--header');
  const search = document.querySelector<HTMLElement>('[js-search-component]');
  const snackbar = document.querySelector<HTMLElement>('[js-snackbar]');
  const snackbarHide = snackbar?.querySelector<HTMLElement>('[js-hide-snackbar]');

  const resizeHandler = () => {
    if (brand === BRANDS.STAYCITY) {
      const resizeComponent = () => {
        if (headerComponentInner && search) {
          if (window.innerWidth < breakpoints.screen1024) {
            const snackbarHeight = snackbar?.getBoundingClientRect().height ?? 0;
            headerComponentInner.style.height = `calc(100dvh - ${snackbarHeight}px)`;
          } else {
            headerComponentInner.removeAttribute('style');
          }
        }
      };
      snackbarHide?.addEventListener('click', () => {
        if (headerComponentInner && search && window.innerWidth < breakpoints.screen1024) {
          setTimeout(() => {
            resizeComponent();
          }, 250);
        }
      });

      resizeComponent();
    }
  };

  ['load', 'resize'].forEach((event) =>
    window.addEventListener(event, () => {
      if (!tickingResize) {
        window.requestAnimationFrame(() => {
          resizeHandler();
          tickingResize = false;
        });
      }
      tickingResize = true;
    })
  );
};
